import Image from 'next/image';
import {useGoogleLogin} from '@react-oauth/google';
import {useLocale, useTranslations} from 'next-intl';
import loginGoogle from 'src/client/methods/loginGoogle';
import SocialButton from 'src/pages/auth/SocialButton';
import {useLogin} from 'src/utils/auth/authUtils';

type Props = {
  onSignInSuccess: (user: User) => void;
  setErrorMessage: (message: string) => void;
};

const GoogleLoginButton = ({onSignInSuccess, setErrorMessage}: Props) => {
  if (process.env.NEXT_PUBLIC_E2E_TEST) return null;

  const t = useTranslations();
  const locale = useLocale();
  const {onLogin} = useLogin();

  const loginFailedMessage = t('auth.login failed', {provider: 'Google'});

  const responseGoogle = (responseObject: any) => {
    loginGoogle(responseObject, locale)
      .then((res) => {
        onLogin(res.token, res.user);
        setTimeout(() => onSignInSuccess(res.user));
      })
      .catch((res) => {
        try {
          res.json().then((res) => {
            setErrorMessage(res.message);
          });
        } catch (err) {
          console.error(err);
          setErrorMessage(loginFailedMessage);
        }
      });
  };

  const onFailure = (error: any) => {
    console.error(error);

    if (error?.message) {
      setErrorMessage(error.message);
    } else {
      setErrorMessage(loginFailedMessage);
    }
  };

  const login = useGoogleLogin({
    flow: 'implicit',
    onSuccess: responseGoogle,
    onError: onFailure
  });

  return (
    <SocialButton
      onClick={login}
      ProviderLogo={<Image src="/icons/googleLogo.svg" alt="Google logo" width={28} height={28} />}
      text={t('auth.continue with google')}
    />
  );
};

export default GoogleLoginButton;
